export default {
    alignToAnchor: Boolean,
    animation: Boolean | Object,
    appendTo: String,
    closeOnClick: Boolean,
    copyAnchorStyles: Boolean,
    dataImageUrlField: String,
    dataSource: Object | Array | kendo.data.HierarchicalDataSource,
    dataSpriteCssClassField: String,
    dataTextField: String,
    dataUrlField: String,
    dataContentField: String,
    direction: String,
    filter: String,
    hoverDelay: Number,
    orientation: String,
    popupCollision: String,
    scrollable: Boolean | Object, 
    showOn: String,
    target: String,

    // Events
    close: Function,
    open: Function,
    activate: Function,
    deactivate: Function,
    select: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoContextMenu/ContextMenuProps.js